import { ME } from "../constants/portfolioData";

/**
 * Footer
 * Simple centered footer with name and year.
 */
const Footer = () => {
  return (
    <>
      <style>{`
        footer { text-align: center; padding: 2rem; border-top: 1px solid var(--border); }
        footer p { font-family: 'IBM Plex Mono', monospace; font-size: 0.72rem; color: var(--muted); }
        footer span { color: var(--accent2); }
      `}</style>
      <footer>
        <p>
          Built by <span>{ME.name}</span> · {new Date().getFullYear()} · Open to opportunities
        </p>
      </footer>
    </>
  );
};

export default Footer;